import { render, staticRenderFns } from "./marketDongList.vue?vue&type=template&id=320d267f&scoped=true&"
import script from "./marketDongList.vue?vue&type=script&lang=js&"
export * from "./marketDongList.vue?vue&type=script&lang=js&"
import style0 from "./marketDongList.vue?vue&type=style&index=0&id=320d267f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320d267f",
  null
  
)

export default component.exports